// extracted by mini-css-extract-plugin
module.exports = {"parent":"styles_parent__3Xvv3","banner":"styles_banner__26743"};